import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";
import { stElemnt } from "../../../St/Reviews/cStyle";
import HeaderM from "./A4/HeaderM";
import LoadingPage from "../../../services/LoadingPage";
import BodyInv from "./A4/BodyInv";
import FooterM from "./A4/FooterM";
import UnderHeader from "./A4/UnderHeader"
import * as _ from "lodash";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import useChunkMyData from "../../../components/Hooks/useChunkMyData";
import { sto } from "../../../Context/InshData";
import { useInvAF } from "../../../St/Reviews/UseStyle";

function BillPage(props) {
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum, foundData } = props;
  const clas = useInvAF();

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>
      <Fragment>

        {found.header_img != null ? (
          (
            <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
              <div>
                <ButtonBase>
                  {" "}
                  <img
                    src={`data:image/jpeg;base64,${found.header_img}`}
                    className={clas.headerImg}
                    alt={found.nameA}
                  />{" "}
                </ButtonBase>
              </div>
            </Grid>
          )
        ) :
          (
            <HeaderM locInv={locInv} foundData={found} sta={sta} />)
        }
        <UnderHeader found={foundData} inv={inv} sta={sta} locInv={locInv} found2={found} />
        <BodyInv
          data={chunk ?? []}
          isFullPage={!isFirst ? true : false}
          isLast={isLast}
          sum={sum}
          inv={inv}
          sta={sta}
          locInv={locInv}
        />
        <FooterM found={found} InvForFatora={inv} data={sta ?? {}} />

      </Fragment>
    </Grid>
  );
}
function MaintainceContainer(props) {
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const [found, setFound] = useState({});
  const [sta, setSta] = useState({});
  const [inv, setInv] = useState({});
  const [foundData, setFoundData] = useState({});
  const [loading, setLoading] = useState(true);
  const [chunks, setChunks] = useState([]);
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  const getInfo = async () => {
    // alert('getInfo')
    const tb = {
      GetFoundation: true,
      Rpt_Inv: true,
      wait: true,
      stor: sto,
      empFound: true,
      parms: {
        lprocid: locInv.proc_id,
        ibranchid: sto.branchi,
        iFoundid: 1,
        branch: sto.branchi,
        sProcTypeInvProc: locInv.ProcTypeInvProc,
      },
      autos: {},
    };
    console.log(tb);
    await axios
      .post(`${uri}Res`, tb)
      .then((res) => {
        setSta({ info: res.data.RptInv, tot: res.data.infoBill });
        console.log("res.data.RptInv");
        // console.log();
        const data2 = res.data.RptInv.map((row, i) => {
          return {
            ...row,
            no: i + 1,
          };
        });
        if (premiApp.billTemplate === 16){
          setChunks(_.chunk(data2, 9));
        }else{
          setChunks(_.chunk(data2, 11));
        }
        // setChunks(_.chunk(data2, 11));
        setFoundData(res.data.FoundData);
        setFound(res.data.Found);
      })
      .catch((error) => {
        console.log("catch");
      });
  };
  const getInv = async () => {
    axios
      .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
      .then((res) => {
        console.log("the inve for fatoora", res.data);
        setInv(res.data);
      })
      .catch((error) => { });
  };
  useEffect(() => {
    setTimeout(async () => {
      await getInfo();
      await getInv();
      setLoading(false);
      // onUnmountComplete();
    }, 0);
  }, []);

  if (!found || !sta || loading) return <LoadingPage />;

  return (
    <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>

      {/* <Typography component="div" style={{ ...stElemnt.AF.Reviws.pdf_page }}> */}
      <Typography component="div" >
        {chunks.map((page, i) => {
          return (
            <BillPage
              {...{
                locInv,
                found,
                sta,
                inv,
                chunk: page,
                isFirst: i == 0,
                isLast: i == chunks.length - 1,
                sum: i + 1,
                foundData,

              }}
            />
          );
        })}
      </Typography>
    </Typography>
  );
}
export default MaintainceContainer;
